import {FC, memo, ReactNode, useEffect, useState} from "react";
import './SequencePollControl.css'
import classnames from "classnames";

const SequencePollControlComponent: FC<{
  icon: ReactNode,
  label: string,
  label2?: ReactNode,
  onClick?: (e: MouseEvent | undefined) => void,
  animationClass?: string,
}> = ({
  icon,
  label,
  label2,
  onClick,
  animationClass,
}) => {

  const [clicked, setClicked] = useState(false)
  const [mouseDown, setMouseDown] = useState(false)

  useEffect(() => {
    const interval = setTimeout(() => {
      if (clicked) {
        setClicked(false)
      }
    }, 1000)

    return () => clearTimeout(interval)
  }, [clicked])

  return (
    <div
      className={classnames(
        "sequence-poll-control-wrapper",
        !onClick ? "view-only" : "",
        clicked ? "clicked" : "",
        animationClass,
        )}
      onMouseDown={() => {
        setMouseDown(Boolean(onClick))
      }}
      onTouchStart={() => {
        setMouseDown(Boolean(onClick))
      }}
      onMouseUp={() => {
        setMouseDown(false)
      }}
      onTouchEnd={() => {
        setMouseDown(false)
      }}
      onClick={(e) => {
        if (onClick) {
          // @ts-ignore
          onClick(e)
          setClicked(true)
        }
    }}>
      { label && (
        <span className={classnames("label", { "mouse-down": mouseDown, "short": label.length < 5 })}>
          {label}
        </span>
      )}
      { label2 }
      <div className={classnames("icon", { "mouse-down": mouseDown })}>
        {icon}
      </div>
    </div>
  )
}

export const SequencePollControl = memo(SequencePollControlComponent)